<template>
    <v-container fluid>
        <skrg_overview_hdr ref="skrg_overview_hdr" class="mb-2" @updateSelection="updateSelection"/>
        <skrg_overview_lst ref="skrg_overview_lst"/>
    </v-container>
</template>
 
<script>
    import skrg_overview_hdr from "@/components/syst/ref/skrg/skrg_overview_hdr.vue";
    import skrg_overview_lst from "@/components/syst/ref/skrg/skrg_overview_lst.vue";

    export default {
        components: {
            skrg_overview_hdr,
            skrg_overview_lst,
        },    
        data() {
            return {
            }
        },    
        methods: { 
            updateSelection(selectionType, selectionValue) {
                this.$refs.skrg_overview_lst.updateSelection(selectionType, selectionValue);
            },
        }
    }
</script> 

<style scoped> 

</style>